import GraniteError from 'granite-admin/utils/granite-error';
import GraniteAPIClient from 'granite-admin/utils/granite-client';
import { env } from 'granite-admin/env';
const url = env.REACT_APP_ACCOUNTS_BASE_URL || process.env.REACT_APP_ACCOUNTS_BASE_URL;
async function getPreferences(path) {
  const params = {
    params: {
      route_path: path
    }
  };
  try {
    const {
      data
    } = await GraniteAPIClient(url).get('user-config/', params);
    return await data.results;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function createPreferences(payload) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).post('user-config/', payload);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
async function updatePreferences(payload, id) {
  try {
    const {
      data
    } = await GraniteAPIClient(url).put(`user-config/${id}/`, payload);
    return data;
  } catch (error) {
    throw new GraniteError(error);
  }
}
export default {
  getPreferences,
  createPreferences,
  updatePreferences
};